import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "core-smart-captcha-container d-flex align-center justify-center",
      attrs: { "data-qa": "core_smart_captcha_container" },
    },
    [
      _c(VProgressCircular, {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_setup.isLoadedCaptchaScript,
            expression: "!isLoadedCaptchaScript",
          },
        ],
        attrs: { size: "32", color: "primary", width: "2", indeterminate: "" },
      }),
      _vm._v(" "),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _setup.isLoadedCaptchaScript,
            expression: "isLoadedCaptchaScript",
          },
        ],
        ref: "captchaRef",
        attrs: { "data-qa": "smart_captcha" },
      }),
      _vm._v(" "),
      _vm.fieldName && _setup.userToken
        ? _c("input", {
            staticClass: "d-none",
            attrs: { name: _vm.fieldName },
            domProps: { value: _setup.userToken },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }